module.exports = __webpack_public_path__ + "static/media/ic_tooltip_hidden.d29e46d1.svg";